<script lang="ts">
	import type { ClassValue } from 'svelte/elements';

	const {
		languageCode,
		isLanguageRTL,
		text,
		classes
	}: { languageCode: string; isLanguageRTL: boolean; text: string; classes?: ClassValue } = $props();
</script>

<span class={classes} lang={languageCode} dir={isLanguageRTL ? 'rtl' : 'ltr'} title="Native name">{text}</span>
